import { Link } from 'react-router-dom';

export const NotFound = () => (
  <main className="min-h-screen hero-height bg-[#fcfcfc] text-charcoal flex flex-col justify-center px-6 md:px-24 relative overflow-hidden">
    <div aria-hidden="true" className="absolute inset-0 flex items-center pointer-events-none select-none">
      <span className="font-grandslang text-[60vw] md:text-[40vw] leading-none text-[#ff6347] opacity-[0.05] -ml-[4vw]">404</span>
    </div>
    <div className="relative max-w-3xl">
      <p className="text-[11px] uppercase tracking-[6px] font-black text-charcoal/40 mb-8">Lost the thread</p>
      <h1 className="font-grandslang text-6xl md:text-8xl leading-[1.05] mb-8">
        This page wandered <span className="text-[#ff6347]">off.</span>
      </h1>
      <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed mb-12 max-w-xl">
        The link may be old, or it was never here. Everything worth seeing is back on the main page.
      </p>
      <Link
        to="/"
        className="inline-flex items-center py-3 px-10 border border-charcoal/40 text-charcoal/70 hover:bg-charcoal hover:text-white transition-all duration-700 text-[11px] uppercase tracking-[8px] font-black"
      >
        Back home
      </Link>
    </div>
  </main>
);
